/** ***********************************************************************
 *
 * Copyright 2024 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */
type SkeletonCallback = (showSkeleton: boolean) => void;

class SkeletonState {
	observers: SkeletonCallback[] = [];
	showSkeleton = true;

	setShowSkeleton = (showSkeleton: boolean) => {
		this.showSkeleton = showSkeleton;
		this.observers.forEach((cb) => cb(showSkeleton));
	};

	getShowSkeleton = () => this.showSkeleton;

	registerObserver = (callback: (showSkeleton: boolean) => void) => {
		this.observers.push(callback);
	};

	unRegisterObserver = (callback: SkeletonCallback) => {
		this.observers = this.observers.filter((cb) => cb !== callback);
	};

	cleanup = () => {
		this.observers = [];
		this.showSkeleton = true;
	};
}

const skeletonState = new SkeletonState();
export {skeletonState};
